import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AccountProvider } from './utils/useAccount';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <AccountProvider>
        <App />
      </AccountProvider>
    </ChakraProvider>
  </React.StrictMode>
);
